/**
 * FR8BOT API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { AdminCarrierBoardSortRequest } from '../model/adminCarrierBoardSortRequest';
// @ts-ignore
import { AdminCarrierListModel } from '../model/adminCarrierListModel';
// @ts-ignore
import { AdminCarrierListRequest } from '../model/adminCarrierListRequest';
// @ts-ignore
import { CarrierRegistrationBoardModel } from '../model/carrierRegistrationBoardModel';
// @ts-ignore
import { CarrierRegistrationBoardRequest } from '../model/carrierRegistrationBoardRequest';
// @ts-ignore
import { PageModelAdminCarrierListModel } from '../model/pageModelAdminCarrierListModel';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';



@Injectable({
  providedIn: 'root'
})
export class AdministrationCarrierRegistrationService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * CARRIER_REGISTRATION_READ: Board
     * @endpoint post /admin/carrier/registration/board
     * @param carrierRegistrationBoardRequest 
     * @param page 
     * @param size 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public adminCarrierRegistrationBoard(carrierRegistrationBoardRequest: CarrierRegistrationBoardRequest, page?: number, size?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<CarrierRegistrationBoardModel>>;
    public adminCarrierRegistrationBoard(carrierRegistrationBoardRequest: CarrierRegistrationBoardRequest, page?: number, size?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<CarrierRegistrationBoardModel>>>;
    public adminCarrierRegistrationBoard(carrierRegistrationBoardRequest: CarrierRegistrationBoardRequest, page?: number, size?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<CarrierRegistrationBoardModel>>>;
    public adminCarrierRegistrationBoard(carrierRegistrationBoardRequest: CarrierRegistrationBoardRequest, page?: number, size?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (carrierRegistrationBoardRequest === null || carrierRegistrationBoardRequest === undefined) {
            throw new Error('Required parameter carrierRegistrationBoardRequest was null or undefined when calling adminCarrierRegistrationBoard.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>page, 'page');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>size, 'size');

        let localVarHeaders = this.defaultHeaders;

        // authentication (Access Token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Access Token', 'Authorization', localVarHeaders, 'Bearer ');

        // authentication (Application Token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Application Token', 'X-FR8BOT-API-TOKEN', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/admin/carrier/registration/board`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<CarrierRegistrationBoardModel>>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: carrierRegistrationBoardRequest,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * CARRIER_REGISTRATION_READ: Set board sort
     * @endpoint post /admin/carrier/registration/board/sort
     * @param adminCarrierBoardSortRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public adminCarrierRegistrationEditBoardSortOrder(adminCarrierBoardSortRequest: AdminCarrierBoardSortRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<AdminCarrierListModel>;
    public adminCarrierRegistrationEditBoardSortOrder(adminCarrierBoardSortRequest: AdminCarrierBoardSortRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<AdminCarrierListModel>>;
    public adminCarrierRegistrationEditBoardSortOrder(adminCarrierBoardSortRequest: AdminCarrierBoardSortRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<AdminCarrierListModel>>;
    public adminCarrierRegistrationEditBoardSortOrder(adminCarrierBoardSortRequest: AdminCarrierBoardSortRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (adminCarrierBoardSortRequest === null || adminCarrierBoardSortRequest === undefined) {
            throw new Error('Required parameter adminCarrierBoardSortRequest was null or undefined when calling adminCarrierRegistrationEditBoardSortOrder.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (Access Token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Access Token', 'Authorization', localVarHeaders, 'Bearer ');

        // authentication (Application Token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Application Token', 'X-FR8BOT-API-TOKEN', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/admin/carrier/registration/board/sort`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<AdminCarrierListModel>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: adminCarrierBoardSortRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * CARRIER_REGISTRATION_READ: List
     * @endpoint post /admin/carrier/registration/list
     * @param adminCarrierListRequest 
     * @param page 
     * @param size 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public adminCarrierRegistrationList(adminCarrierListRequest: AdminCarrierListRequest, page?: number, size?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<PageModelAdminCarrierListModel>;
    public adminCarrierRegistrationList(adminCarrierListRequest: AdminCarrierListRequest, page?: number, size?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<PageModelAdminCarrierListModel>>;
    public adminCarrierRegistrationList(adminCarrierListRequest: AdminCarrierListRequest, page?: number, size?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<PageModelAdminCarrierListModel>>;
    public adminCarrierRegistrationList(adminCarrierListRequest: AdminCarrierListRequest, page?: number, size?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (adminCarrierListRequest === null || adminCarrierListRequest === undefined) {
            throw new Error('Required parameter adminCarrierListRequest was null or undefined when calling adminCarrierRegistrationList.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>page, 'page');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>size, 'size');

        let localVarHeaders = this.defaultHeaders;

        // authentication (Access Token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Access Token', 'Authorization', localVarHeaders, 'Bearer ');

        // authentication (Application Token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Application Token', 'X-FR8BOT-API-TOKEN', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/admin/carrier/registration/list`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<PageModelAdminCarrierListModel>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: adminCarrierListRequest,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

}
